const configs = {
    development: {
      API_URL: 'http://localhost:5005',
    },
    production: {
      API_URL: 'https://genericapp.io',
    },
  };
  
  // Default to 'development' unless NODE_ENV is explicitly set to 'production'
  const env = process.env.NODE_ENV === 'production' ? 'production' : 'development';
  
  console.log(`Running in ${env.toUpperCase()} environment`);
  
  export const config = configs[env];



//   dev
// const API_URL = 'http://localhost:5005'; // Base URL for Flask API, adjust if running on a different port

//dev with backend on NAS 
//const API_URL = 'https://192.168.1.100:5005'; // Base URL for Flask API, adjust if running on a different port

//prod extenral 
//const API_URL = 'https://genericapp.io:5005'; // Base URL for Flask API, adjust if running on a different port